import { FieldValues, Path } from "react-hook-form";

import { selectInputOnFocus } from "#shared/helpers/selectInputOnFocus";
import { MultiSelectInput } from "#shared/view/designSystem/MultiSelectInput";

import {
  BaseSelectInputController,
  BaseSelectInputControllerProps,
} from "./BaseSelectInputController";

export const MultiSelectInputController = <
  T extends FieldValues,
  IP extends Record<string, unknown> = Record<string, unknown>,
>(
  props: Omit<BaseSelectInputControllerProps<T, IP>, "InputComponent"> & {
    name: Path<T>;
    data: { value: string; label: string }[];
  },
) => {
  return (
    <BaseSelectInputController<T, IP>
      {...(props as BaseSelectInputControllerProps<T, IP>)}
      InputComponent={MultiSelectInput}
      onFocus={selectInputOnFocus}
    />
  );
};
